<script>
import {useDeviceModelsStore} from "@/stores/deviceModels.js";
import {mapStores} from "pinia";
import FilterCheckbox from "@/Forms/Filters/FilterCheckbox.vue";

export default {
  name: "FilterDeviceModelsTab",
  inheritAttrs: false,
  components: {FilterCheckbox},
  computed: {
    ...mapStores(useDeviceModelsStore),
  },
  mounted() {
    console.log(this.$options.name);
    this.deviceModelsStore.indexDeviceModelOptions();
  },
}
</script>

<template>
  <p class="font-bold text-xl mb-4">Device Models</p>
  <div class="card flex flex-wrap justify-content-center gap-3">
    <FilterCheckbox
        v-for="deviceModel in deviceModelsStore.getDeviceModelOptions"
        v-bind="$attrs"
        :value="deviceModel.id"
        :label="deviceModel.name"
    />
  </div>
</template>

<style scoped>

</style>